import { render, staticRenderFns } from "./SecretPrescriptionMngtDetail.vue?vue&type=template&id=0ca263b4"
import script from "./SecretPrescriptionMngtDetail.vue?vue&type=script&lang=js"
export * from "./SecretPrescriptionMngtDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports